module.exports = __webpack_public_path__ + "static/media/tag.84662c64.png";